/* Havvok cart upsell — size select + Add.
   The Add button is a real submit button inside the theme's product-form-component, so the
   theme runs the actual /cart/add + cart:update. Document-delegated, so it survives every cart
   drawer morph. Only ever touches our own [data-hvk-*] elements — cannot affect the rest of the cart. */
(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || typeof t.closest !== 'function') return;

    /* ---- a size pill was tapped ---- */
    var pill = t.closest('[data-hvk-size]');
    if (pill && !pill.hasAttribute('disabled')) {
      var card = pill.closest('.hvk-upsell__card');
      if (!card) return;
      var form = card.querySelector('form');
      var idInput = form && form.querySelector('input[name="id"]');
      if (!idInput) return;

      idInput.value = pill.getAttribute('data-variant-id');

      var pills = card.querySelectorAll('[data-hvk-size]');
      for (var i = 0; i < pills.length; i++) pills[i].classList.remove('is-selected');
      pill.classList.add('is-selected');

      var addBtn = card.querySelector('[data-hvk-add-btn]');
      if (addBtn) {
        addBtn.removeAttribute('disabled');
        addBtn.textContent = 'Add ' + (pill.textContent || '').trim();
      }
      return;
    }

    /* ---- the Add button was tapped (it is type=submit; we do NOT preventDefault) ---- */
    var addBtn2 = t.closest('[data-hvk-add-btn]');
    if (addBtn2 && !addBtn2.hasAttribute('disabled') && addBtn2.getAttribute('data-hvk-busy') !== 'true') {
      addBtn2.setAttribute('data-hvk-busy', 'true');
      addBtn2.classList.add('is-added');
      addBtn2.textContent = '✓ Added';

      /* self-heal: if the add failed and the card is still on screen after 3s, allow a retry */
      var card2 = addBtn2.closest('.hvk-upsell__card');
      setTimeout(function () {
        if (card2 && card2.isConnected) {
          addBtn2.removeAttribute('data-hvk-busy');
          addBtn2.classList.remove('is-added');
          var sel = card2.querySelector('[data-hvk-size].is-selected');
          addBtn2.textContent = sel ? ('Add ' + (sel.textContent || '').trim()) : 'Select a size';
        }
      }, 3000);
    }
  });
})();